import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    rdnCenterAlias: {
        color: 'red'
    },
    validationAlert: {
        marginTop: 8,
        marginBottom: 0
    },
    rescheduleWell: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    answerButton: {
        marginRight: 5
    }
};
